/*
 * @providesModule BannerStyle
 */

import {StyleSheet, Dimensions} from 'react-native';
import Sizes from 'Sizes';

export const BANNER_BAR_HEIGHT = Sizes.isTablet() ? 84 : 66;

// Calculate responsive banner width that fits the screen with padding
const getResponsiveBannerWidth = () => {
  const screenWidth = Dimensions.get('window').width;
  const maxWidth = Sizes.isTablet() ? 430 : 359;
  const minPadding = 32; // 16px padding on each side
  return Math.min(maxWidth, screenWidth - minPadding);
};

export const BANNER_WIDTH = getResponsiveBannerWidth();
export default StyleSheet.create({
  containerIos: {
    width: BANNER_WIDTH,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#FFFFFF',
    borderStyle: 'solid',
    shadowOffset: {
      width: 0.75,
      height: 1.75,
    },
    shadowRadius: 3,
    shadowColor: 'rgba(0, 0, 0, 0.25)',
    shadowOpacity: 1,
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 11,
    marginBottom: 8,
  },

  containerAndroid: {
    width: BANNER_WIDTH,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#FFFFFF',
    borderStyle: 'solid',
    borderRadius: 10,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 11,
    marginBottom: 8,
    elevation: 4,
  },

  smallBarInfoIcon: {
    marginLeft: 8,
    width: 4,
    height: BANNER_BAR_HEIGHT,
    backgroundColor: '#4890E8',
    borderRadius: 10,
  },

  smallBarErrorIcon: {
    marginLeft: 8,
    width: 4,
    height: BANNER_BAR_HEIGHT,
    backgroundColor: '#DD6952',
    borderRadius: 10,
  },

  largeBarIcon: {
    marginLeft: 8,
    width: 4,
    height: 102,
    backgroundColor: '#4890E8',
    borderRadius: 10,
  },

  icon: {
    height: 26,
    width: 26,
    marginLeft: 12,
  },

  textContainer: {
    flex: 1,
    marginVertical: 16,
    marginLeft: 12,
    marginRight: 8,
  },

  titleText: {
    color: '#000000',
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 19 : 16,
  },

  messageText: {
    color: '#757575',
    fontFamily: 'OpenSans-Regular',
    fontSize: Sizes.isTablet() ? 16 : 14,
  },

  hyperLink: {
    color: 'rgba(72, 144, 232, 1)',
    fontFamily: 'OpenSans-Regular',
    fontSize: Sizes.isTablet() ? 16 : 14,
    height: 19,
  },

  closeBtn: {
    height: 24,
    width: 24,
    marginLeft: 12,
    marginRight: 16,
  },

  closeIcons: {
    height: 24,
    width: 24,
  },
});
